import { CountryCodes } from '@e3dc-react/shell/Hooks/useCountryOptions'
import { useTypedSelector } from 'src/State/RootReducer'
import { getIsDppAvailableForInstallationLocation } from '../utils/price-settings'

interface InstallationLocation {
  countryCode: CountryCodes | undefined
  isDppCountryInstallation: boolean
}

/**
 * This hook returns the installation location and checks if dynamic power prices (DPP) are available for that location.
 */
const useCheckInstallationLocation = (): InstallationLocation => {
  const installation = useTypedSelector(state => state.storage.installation)
  const countryCode = installation?.countryCode as CountryCodes
  const isDppCountryInstallation = getIsDppAvailableForInstallationLocation(countryCode)

  return { countryCode, isDppCountryInstallation }
}

export default useCheckInstallationLocation
